import { supabase } from '@/shared/lib/supabase/client';
import { AppError, unwrapMaybe } from '@/shared/lib/repository/errors';
import type { Tables } from '@/shared/types/tables';
import type { LoginInput, SignUpInput } from '@auditwire/contracts';

/** All authentication + profile data access lives here (no SDK calls elsewhere). */
export const authRepository = {
  async getProfile(userId: string): Promise<Tables<'profiles'> | null> {
    return unwrapMaybe(await supabase.from('profiles').select('*').eq('id', userId).maybeSingle());
  },

  async signIn(input: LoginInput): Promise<void> {
    const { error } = await supabase.auth.signInWithPassword({
      email: input.email,
      password: input.password,
    });
    if (error) throw new AppError(error.message, String(error.status ?? ''), error);
  },

  async signUp(input: SignUpInput): Promise<void> {
    const { error } = await supabase.auth.signUp({
      email: input.email,
      password: input.password,
      options: { data: { name: input.name } },
    });
    if (error) throw new AppError(error.message, String(error.status ?? ''), error);
  },

  async signOut(): Promise<void> {
    const { error } = await supabase.auth.signOut();
    if (error) throw new AppError(error.message, String(error.status ?? ''), error);
  },
};
